export const CATEGORIES = [
  { value: 'material', label: 'Material' },
  { value: 'service', label: 'Service' },
  { value: 'miscellaneous', label: 'Miscellaneous' },
  { value: 'assets', label: 'Assets' },
  { value: 'partner_fund', label: 'Partner Fund' },
  { value: 'customer_fund', label: 'Customer Fund' },
  { value: 'internal_transfer', label: 'Internal Transfer' },
  { value: 'other', label: 'Other' },
];

export const PARENT_CATEGORIES = [
  { value: 'material', label: 'Material' },
  { value: 'service', label: 'Service' },
  { value: 'miscellaneous', label: 'Miscellaneous' },
  { value: 'assets', label: 'Assets' },
];

export const CATEGORY_LABELS = {
  material: 'Material',
  service: 'Service',
  miscellaneous: 'Miscellaneous',
  assets: 'Assets',
  partner_fund: 'Partner Fund',
  customer_fund: 'Customer Fund',
  internal_transfer: 'Internal Transfer',
  other: 'Other',
};

export const PAYMENT_MODES = [
  { value: 'cash', label: 'Cash' },
  { value: 'bank', label: 'Bank' },
];

export const SUB_CAT_CATEGORIES = ['material', 'service', 'miscellaneous', 'assets'];

export const SUB_CAT_LABEL = {
  material: 'Material',
  service: 'Service',
  miscellaneous: 'Misc. Type',
  assets: 'Asset Type',
};

export const SUB_CAT_PLURAL = {
  material: 'Materials',
  service: 'Services',
  miscellaneous: 'Misc. Types',
  assets: 'Asset Types',
};

export const CATEGORY_DOT_COLOR = {
  material: 'bg-blue-500',
  service: 'bg-purple-500',
  miscellaneous: 'bg-amber-500',
  assets: 'bg-emerald-500',
};

export const CATEGORY_BADGE_CLASS = {
  material: 'bg-blue-50 dark:bg-blue-950/30 text-blue-700 dark:text-blue-400',
  service: 'bg-purple-50 dark:bg-purple-950/30 text-purple-700 dark:text-purple-400',
  miscellaneous: 'bg-amber-50 dark:bg-amber-950/30 text-amber-700 dark:text-amber-400',
  assets: 'bg-emerald-50 dark:bg-emerald-950/30 text-emerald-700 dark:text-emerald-400',
};

export function getEntityTypeForCategory(cat) {
  if (SUB_CAT_CATEGORIES.includes(cat)) return 'vendor';
  if (cat === 'partner_fund') return 'partner';
  if (cat === 'customer_fund') return 'customer';
  return null;
}
